/* Project Import will be here */
import { getErrorObject, mergeMultipleSchemeProducts, normalizeByGroup } from 'utilities/utils';
import { applyFilterApi } from "services/products";
import Constants from "utilities/appConstants";
import { initializeExchangeOrderSummary } from "./exchangeOrderSummary";
/* Project Import will be here */

export const types = {
    EXCHANGE_ORDER_PRODUCTS_REQUEST: "exchangeOrderProducts/EXCHANGE_ORDER_PRODUCTS_REQUEST",
    EXCHANGE_ORDER_PRODUCTS_SUCCESS: "exchangeOrderProducts/EXCHANGE_ORDER_PRODUCTS_SUCCESS",
    EXCHANGE_ORDER_PRODUCTS_FAILURE: "exchangeOrderProducts/EXCHANGE_ORDER_PRODUCTS_FAILURE",
    EXCHANGE_ORDER_PRODUCTS_NEXT_PAGE_REQUEST: "exchangeOrderProducts/EXCHANGE_ORDER_PRODUCTS_NEXT_PAGE_REQUEST",
    RESET_EXCHANGE_ORDER_PRODUCTS: "exchangeOrderProducts/RESET_EXCHANGE_ORDER_PRODUCTS",
    EXCHANGE_ORDER_PRODUCTS_UPDATE_IS_FAV: "exchangeOrderProducts/EXCHANGE_ORDER_PRODUCTS_UPDATE_IS_FAV",
    EXCHANGE_ORDER_PRODUCTS_SHOW_MORE_PRODUCT_BUTTON_DISABLE: "exchangeOrderProducts/EXCHANGE_ORDER_PRODUCTS_SHOW_MORE_PRODUCT_BUTTON_DISABLE",
};

const initialFilterState: ISalesReturnProducts = {
    Page: 1,
    FilterLevelCode: "SUCAT",
    FilterIdList: [],
    AttrFilter: [],
    Sorting: Constants.DEFAULT,
};

const initialState = {
    filter: initialFilterState,
    groupIds: [],
    group: {},
    isLoading: false,
    ids: [],
    data: {},
    count: null,
    totalCount: 0,
    noOfItemsReceived: 0,
    IsShowShowMoreProductButton: true,
    error: null,
};

export const exchangeOrderProducts = (state = initialState, action) => {
    switch (action.type) {
        case types.EXCHANGE_ORDER_PRODUCTS_REQUEST:
            return {
                ...initialState,
                IsShowShowMoreProductButton: true,
                filter: {
                    ...state.filter,
                    ...action.payload
                },
                isLoading: true
            };
        case types.EXCHANGE_ORDER_PRODUCTS_SUCCESS:
            return {
                ...state,
                ...action.payload,
                error: null,
                isLoading: false
            };
        case types.EXCHANGE_ORDER_PRODUCTS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error
            };
        case types.RESET_EXCHANGE_ORDER_PRODUCTS:
            return {
                ...initialState
            };
        case types.EXCHANGE_ORDER_PRODUCTS_NEXT_PAGE_REQUEST:
            return {
                ...state,
                filter: {
                    ...state.filter,
                    Page: action.payload.nextPage
                },
                error: null,
                isLoading: true
            };
        case types.EXCHANGE_ORDER_PRODUCTS_SHOW_MORE_PRODUCT_BUTTON_DISABLE:
            return {
                ...state,
                filter: {
                    ...state.filter,
                },
                IsShowShowMoreProductButton: action.payload,
                error: null
            };
        case types.EXCHANGE_ORDER_PRODUCTS_UPDATE_IS_FAV:
            let { ProductId, IsFavourite } = action.payload;
            if (ProductId in state.data) {
                return {
                    ...state,
                    data: { ...state.data, [ProductId]: { ...state.data[ProductId], IsFavourite: IsFavourite === 0 ? 1 : 0 } },
                    error: null,
                    isLoading: false
                }
            }
            else {
                return state;
            }
        default:
            return state;
    }
};

export const getExchangeOrderProducts = (subCatId) => {
    return async (dispatch, getState) => {
        const requestObj = {
            FilterLevelCode: "SUCAT",
            FilterIdList: [subCatId],
            Page: 1,
            Sorting: getState().appSettings.defaultProductSorting
        };
        await dispatch({
            type: types.EXCHANGE_ORDER_PRODUCTS_REQUEST,
            payload: { ...requestObj }
        });

        dispatch(getProductList());
    };
};

const getProductList = () => {
    return async (dispatch, getState) => {
        try {
            const response = await applyFilterApi(getState().exchangeOrderProducts.filter);

            /* Merge the multi scheme products */
            const mergedProductList = mergeMultipleSchemeProducts(response.data.Data);

            let payload = normalizeByGroup({
                data: mergedProductList,
                key: "ProductId",
                groupKey: "GroupId"
            });
            payload.count = response.data.Count;
            payload.totalCount = response.data.TotalCount;
            payload.noOfItemsReceived = response.data.Data.length;

            dispatch({ type: types.EXCHANGE_ORDER_PRODUCTS_SUCCESS, payload });

            /* Initialize Exchange Order Summary */
            dispatch(initializeExchangeOrderSummary(payload));
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.EXCHANGE_ORDER_PRODUCTS_FAILURE));
        }
    };
};

export const resetExchangeOrderProducts = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.RESET_EXCHANGE_ORDER_PRODUCTS });
    };
};

export const getExchangeOrderProductsNextPage = (nextPage) => {
    return async (dispatch, getState) => {
        await dispatch({
            type: types.EXCHANGE_ORDER_PRODUCTS_NEXT_PAGE_REQUEST,
            payload: { nextPage }
        });

        try {
            /* Get the applied filter */
            const filters = getState().exchangeOrderProducts.filter;

            /* get sales return products with the applied filter conditions */
            const response = await applyFilterApi(filters);

            /* Merge the multi scheme products */
            const mergedProductList = mergeMultipleSchemeProducts(response.data.Data);

            let payload = normalizeByGroup({
                data: mergedProductList,
                key: "ProductId",
                groupKey: "GroupId"
            });
            payload.count = mergedProductList.length;

            if (mergedProductList.length > 0) {
                const oldProducts = getState().exchangeOrderProducts;
                const newState = {
                    groupIds: [...oldProducts.groupIds, ...payload.groupIds],
                    group: { ...oldProducts.group, ...payload.group },
                    ids: [...oldProducts.ids, ...payload.ids],
                    data: { ...oldProducts.data, ...payload.data }
                };
                newState.count = response.data.Count;
                newState.totalCount = response.data.TotalCount;
                newState.noOfItemsReceived = oldProducts.noOfItemsReceived + response.data.Data.length;

                dispatch({ type: types.EXCHANGE_ORDER_PRODUCTS_SUCCESS, payload: newState });

                /* Initialize Exchange PlaceOrder Summary */
                dispatch(initializeExchangeOrderSummary(payload));
            }
        }
        catch (error) {
            dispatch({
                type: types.EXCHANGE_ORDER_PRODUCTS_SHOW_MORE_PRODUCT_BUTTON_DISABLE,
                payload: false
            });
            dispatch(promiseCatchBlock(error, types.EXCHANGE_ORDER_PRODUCTS_FAILURE));
        }
    };
};

export const applyExchangeOrderAttributeFilter = () => {
    return async (dispatch, getState) => {
        /* Get attr filter state */
        const attrFilter = getState().attrFilter;

        /* Get product filter state */
        let filterObj = getState().exchangeOrderProducts.filter;

        /* Update the product filter state based on attr filter state */
        filterObj.Page = 1;
        filterObj.AttrFilter = attrFilter.selectedAttrFilter;
        filterObj.Sorting = attrFilter.selectedSortingFilter;

        /* Dispatch the updated state */
        await dispatch({ type: types.EXCHANGE_ORDER_PRODUCTS_REQUEST, payload: { ...filterObj } });

        dispatch(getProductList());
    };
};

/* Generic code for promise catch block */
const promiseCatchBlock = (error: any, type: string) => {
    return (dispatch) => {
        const { message } = getErrorObject(error);
        dispatch({
            type: type,
            payload: { error: message }
        });
    }
};